export const userRoles = {
  ADMIN: 'ADMIN',
  PROCURER: 'PROCURER',
  SUPPLIER: 'SUPPLIER',
} as const;

export const procurerCompletedSteps = {
  GEOGRAPHY: 'geography',
  THEMES: 'themes',
  IMPACT: 'impact',
  SCORING: 'scoring',
  QUALITATIVE: 'qualitative',
  FINALIZING: 'finalizing',
};

export const applicationStatuses = {
  PENDING: 'PENDING',
  SUBMITTED: 'SUBMITTED',
  REVIEWED: 'REVIEWED',
  AWARDED: 'AWARDED',
  REJECTED: 'REJECTED',
};

export enum SupplierApplicationDisplayStatus {
  PENDING = 'In-Progress',
  SUBMITTED = 'Submitted',
  REVIEWED = 'Reviewed',
  AWARDED = 'Awarded',
  REJECTED = 'Rejected',
  CHANGES_REQUESTED = 'Changes requested',
}

export enum ReportStatus {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  CHANGES_REQUESTED = 'CHANGES_REQUESTED',
  APPROVED = 'APPROVED',
}
